module.exports = __webpack_public_path__ + "assets/multiple-users-silhouette.f6f55b24.svg";